/**
 * itemUtilsConstant Constant
 * @namespace linshare.utils
 */
(function(){
  'use strict';

  angular
    .module('linshare.utils')
    .constant('itemUtilsConstant', {
      CONTACTS_LIST: 'CONTACTS_LIST',
      CONTACTS_LIST_CONTACT: 'CONTACTS_LIST_CONTACT',
      DOCUMENT: 'DOCUMENT',
      GUEST: 'GUEST',
      RECEIVED_SHARE: 'RECEIVED_SHARE',
      WORKGROUP: 'WORKGROUP',
      DRIVE: 'DRIVE',
      WORKGROUP_AND_DRIVE: 'WORKGROUP_AND_DRIVE',
      WORKGROUP_NODE: 'WORKGROUP_NODE',
      WORKGROUP_VERSION: 'WORKGROUP_VERSION',
      WORKGROUP_VERSION_LAST: 'WORKGROUP_VERSION_LAST',
      WORKGROUP_VERSION_ALL: 'WORKGROUP_VERSION_ALL'
    });
})();
